import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { computed } from 'vue';

interface Props {
	icon: string,
	title: string,
	size?: 'small' | 'medium',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IconInfoHeader',
  props: {
    icon: {},
    title: {},
    size: { default: 'small' }
  },
  setup(__props: any) {

const props = __props;

const elementClasses = computed(() => ({
	[`icon-info-header--${props.size}`]: props.size,
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['icon-info-header', elementClasses.value])
  }, [
    _createVNode(BaseIcon, {
      class: "icon-info-header__icon",
      name: _ctx.icon
    }, null, 8 /* PROPS */, ["name"]),
    _createElementVNode("span", {
      class: "icon-info-header__title",
      textContent: _toDisplayString(_ctx.title)
    }, null, 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}
}

})